import React, { useEffect, useState, useCallback } from "react";
import Web3 from "web3";
import { useAppKitAccount } from "@reown/appkit/react";
import { useConnectorClient } from "wagmi";

import { NFTContarct, USDTContarct } from "../config/contractConfig";
import NFTABI from "../abis/NFTABI.json";
import USDTABI from "../abis/USDTABI.json";

import Loader from "../components/Loader";
import BNB from "../assets/bnb.svg";


import {FaCopy, FaCheck } from "react-icons/fa";
const SellNft = () => {
  const { address, isConnected } = useAppKitAccount();
  const { data: client } = useConnectorClient();

  const [web3, setWeb3] = useState(null);
  const [listedNFTCount, setListedNFTCount] = useState(0);

  const [allNFTs, setAllNFTs] = useState([]);
  const [visibleNFTs, setVisibleNFTs] = useState([]);
  const [search, setSearch] = useState("");
  const [sortOrder, setSortOrder] = useState("desc");
  const [loading, setLoading] = useState(true);
  const [loadingSkeleton, setLoadingSkeleton] = useState(Array(12).fill(0));

  // Initialize Web3
  useEffect(() => {
    if (client?.transport) setWeb3(new Web3(client.transport));
    else if (window.ethereum) setWeb3(new Web3(window.ethereum));
  }, [client]);

  // Fetch all listed NFTs from contract
  const loadAllListedNFTs = useCallback(async () => {
    if (!web3 || !address) return;
    setLoading(true);

    try {
      const NFT = new web3.eth.Contract(NFTABI, NFTContarct);

      const result = await NFT.methods.getAllActiveListedNFTs().call();

      // Safe BigInt handling
      const tokenIds = result[0].map((id) => id.toString());
      const owners = result[1]; 
      const prices = result[2].map((p) => web3.utils.fromWei(p.toString(), "ether"));
      const images = result[3];

      const nftList = tokenIds.map((id, i) => ({
        tokenId: id,
        owner: owners[i],
        price: prices[i],
        image: images[i],
      }));

      setAllNFTs(nftList);
      setVisibleNFTs(nftList);
      setListedNFTCount(nftList.length);

    } catch (err) {
      console.error("Error fetching all listed NFTs:", err);
    } finally {
      setLoading(false);
    }
  }, [web3, address]);

  useEffect(() => {
    if (isConnected && web3) loadAllListedNFTs();
  }, [isConnected, web3, loadAllListedNFTs]);

  // Search + Sort
  const filtered = visibleNFTs
    .filter((n) => {
      if (!search) return true;
      return (
        n.tokenId.includes(search) ||
        n.owner?.toLowerCase().includes(search.toLowerCase())
      );
    })
    .sort((a, b) => {
      const A = window.BigInt(a.tokenId);
      const B = window.BigInt(b.tokenId);
      return sortOrder === "asc" ? Number(A - B) : Number(B - A);
    });

  // Handle Buy
  const handleBuyNow = async (nft) => {
    if (!address || !web3) {
      alert("Wallet not connected");
      return;
    }
    await PreAuthorizeNFT(nft.tokenId, nft.price);
  };

  // Pre-approve USDT if allowance not enough
  const PreAuthorizeNFT = async (tokenId, priceUSDT) => {
    try {
      const USDT = new web3.eth.Contract(USDTABI, USDTContarct);
      const amountInWei = web3.utils.toWei(priceUSDT.toString(), "ether");

      const allowance = await USDT.methods.allowance(address, NFTContarct).call();
      if (window.BigInt(allowance) >= window.BigInt(amountInWei)) {
        await BuyNFT(tokenId);
        return;
      }

      USDT.methods
        .approve(NFTContarct, amountInWei)
        .send({ from: address })
        .on("receipt", async () => {
          await BuyNFT(tokenId);
        })
        .on("error", (err) => {
          console.log("Approve Failed:", err.message);
        });

    } catch (error) {
      console.log("General Approval Error:", error.message);
    }
  };

  // Execute NFT purchase
  const BuyNFT = async (tokenId) => {
    try {
      const NFT = new web3.eth.Contract(NFTABI, NFTContarct);

      NFT.methods
        .buyNFT(tokenId)
        .send({ from: address })
        .on("transactionHash", (hash) => console.log("Buy Tx Hash:", hash))
        .on("receipt", async (receipt) => {
          alert(`🎉 Successfully purchased NFT #${tokenId}`);
          await loadAllListedNFTs();
        })
        .on("error", (err) => console.log("BuyNFT Error:", err.message));

    } catch (error) {
      console.log("General NFT Purchase Error:", error.message);
    }
  };


  const [copiedIndex, setCopiedIndex] = useState(null);

const handleCopy = (address, index) => {
  navigator.clipboard.writeText(address);
  setCopiedIndex(index);
  setTimeout(() => setCopiedIndex(null), 1200);
};



  if (loading) return <Loader />;

  return (
    <div className="page">
      <h2 className="page-title mb-3">
        <span className="text-gradeint">All Listed NFTs ({listedNFTCount})</span>
      </h2>

      {/* Search + Sort */}
      <div className="row justify-content-end mb-3">
        <div className="col-md-7">
          <div className="filter-right">
            <input
              type="text"
              placeholder="Search NFTs..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            <select value={sortOrder} onChange={(e) => setSortOrder(e.target.value)}>
              <option value="desc">DESC</option>
              <option value="asc">ASC</option>
            </select>
          </div>
        </div>
      </div>

      <div className="row">
        {filtered.map((nft, i) => (



<div className="col-6 col-md-4 col-lg-3 mb-4" key={i}>
  <div className="NFT-card">
    <div className="NFT-card-img">
      <img
        src={nft.image}
        alt={`NFT ${nft.tokenId}`}
        style={{ width: "100%", borderRadius: 10 }}
      />
    </div>

    <div className="NFT-card-body">

      <div className="blockchain-row">
        <span className="blockchain-span">
          <img src={BNB} width={22} alt="" />
        </span>
        <div className="badge" style={{ background: "#16c784" }}>ON SALE</div>
      </div>

      <div className="subtitle-price">USDT {nft.price}</div>

      <div className="Owner-row">

        <div className="subtitle-new">
          NFT <b className="text-warning">#{nft.tokenId}</b>
        </div>

        <div className="footer-new d-flex align-items-center">
          <span>
            Owner:{" "}
            <b className="text-warning">
              {nft.owner.slice(0, 4)}***{nft.owner.slice(-4)}
            </b>
          </span>

          {/* COPY BUTTON (Same UI as previous pages) */}
          <div className="ref-copy-box" style={{ marginLeft: "8px" }}>
            <button
              className="copy-btn"
              onClick={() => handleCopy(nft.owner, i)}
            >
              {copiedIndex === i ? (
                <FaCheck className="copy-icon copied" />
              ) : (
                <FaCopy className="copy-icon" />
              )}
            </button>
          </div>

        </div>
      </div>

      <button
        className="new_joining_btn"
        onClick={() => handleBuyNow(nft)}
      >
        <i className="fa-solid fa-cart-arrow-down me-1"></i>
        Buy Now
      </button>

    </div>
  </div>
</div>


          // <div className="col-6 col-md-4 col-lg-3 mb-4" key={i}>
          //   <div className="NFT-card">
          //     <div className="NFT-card-img">
          //       <img src={nft.image} alt={`NFT ${nft.tokenId}`} style={{ width: "100%", borderRadius: 10 }} />
          //     </div>
          //     <div className="NFT-card-body">
          //       <div className="blockchain-row">
          //         <span className="blockchain-span"><img src={BNB} width={22} alt="" /></span>
          //         <div className="badge" style={{ background: "#16c784" }}>ON SALE</div>
          //       </div>
          //       <div className="subtitle-price">USDT {nft.price}</div>
          //       <div className="Owner-row">
          //         <div className="subtitle-new">NFT <b className="text-warning">#{nft.tokenId}</b></div>
          //         <div className="footer-new">
          //           <span>Owner: <b className="text-warning">{nft.owner.slice(0,4)}***{nft.owner.slice(-4)}</b></span>
          //         </div>
          //       </div>
          //       <button className="new_joining_btn" onClick={() => handleBuyNow(nft)}>
          //         <i className="fa-solid fa-cart-arrow-down me-1"></i> Buy Now
          //       </button>
          //     </div>
          //   </div>
          // </div>
        ))}

        {/* Skeleton while loading */}
        {loadingSkeleton.map((_, i) => (
          <div className="col-6 col-md-4 col-lg-3 mb-4" key={"s" + i}>
            <div className="skeleton-card">
              <div className="skeleton-box"></div>
              <div className="NFT-card-body">
                <div className="skeleton-line w-50"></div>
                <div className="skeleton-line w-30"></div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SellNft;
